module.exports = __webpack_public_path__ + "img/img16.de391f84.svg";